<template>
<v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="success"
          v-bind="attrs"
          v-on="on"
        >
          {{ $$t('new') }}
        </v-btn>
      </template>

      <v-card>
        <v-form @submit="save">
          <v-card-text>
            <v-skeleton-loader
              :loading="isLoading"
              transition="expand-transition"
              type="article"
            >
              <v-text-field
                :label="$$t('content')"
                v-model="editCollegeDocumentQuestion.content"
              ></v-text-field>
            </v-skeleton-loader>
          </v-card-text>
          <v-card-actions>
            <v-btn color="default" text class="ml-4 btn-cancel" @click="cancel">
              {{ $t('common.buttons.cancel') }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="success" type="submit">
              {{$t('common.buttons.save')}}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ModalCollegeDocumentQuestion',
  module: 'Membership',
  mixins: [loading],
  props: ['ordering'],
  data() {
    return {
      /**
      * Get/Set editing CollegeDocumentQuestion. Default to {}.
      */
      editCollegeDocumentQuestion: {
        collegeDocumentId: this.$route?.query.collegeDocumentId,
        ordering: this.ordering,
      },
      /**
       * Query Id for CollegeDocumentQuestion
       */
      collegeDocumentQuestionId: this.$route?.query.id,
      collegeDocumentId: this.$route?.query.collegeDocumentId,
      dialog: false,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('collegeDocumentQuestions', ['collegeDocumentQuestions', 'collegeDocumentQuestion']),
    /** Get the mode for this view, create or update
     */
    mode() {
      if (this.collegeDocumentQuestionId) {
        return 'edit';
      }
      return 'add';
    },
  },
  watch: {
    ordering() {
      this.editCollegeDocumentQuestion.ordering = this.ordering;
    },
  },
  async mounted() {
    this.isLoading = true;
    if (this.mode === 'edit') {
      await this.LOAD_collegeDocumentQuestion(this.collegeDocumentQuestionId);
      this.editCollegeDocumentQuestion = this.collegeDocumentQuestion;
    }
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('collegeDocumentQuestions', ['LOAD_collegeDocumentQuestion', 'CREATE_collegeDocumentQuestion', 'UPDATE_collegeDocumentQuestion']),
    cancel() {
      this.editCollegeDocumentQuestion.content = '';
      this.dialog = false;
    },
    /** Method used to save the item
     */
    async save() {
      const { editCollegeDocumentQuestion } = this;
      this.isSaving = true;
      if (this.mode === 'add') {
        await this.CREATE_collegeDocumentQuestion(editCollegeDocumentQuestion);
      } else {
        await this.UPDATE_collegeDocumentQuestion(editCollegeDocumentQuestion);
      }
      this.isSaving = false;
      this.$emit('added', editCollegeDocumentQuestion);
      this.dialog = false;
    },
  },
};
</script>

<docs>
# EditCollegeDocumentQuestion example

'''js
<EditCollegeDocumentQuestion :CollegeDocumentQuestion="CollegeDocumentQuestion" />
'''
</docs>
